'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { OrbitControls } from '@react-three/drei';
import { useXR } from '@react-three/xr';
export default function SpaceCanvasControls({ orbitControlsRef, navigationMode, }) {
    const session = useXR((state) => state.session);
    return (_jsx(OrbitControls, { ref: orbitControlsRef, makeDefault: true, enableDamping: navigationMode === 'free', dampingFactor: 0.05, enabled: !session && navigationMode === 'free' }));
}
